import {apiClient} from 'core/apiClient';
import {
    RecallAuditEntry,
    RecallAuditExportParams,
    RecallAuditExportResult,
    RecallAuditListParams,
    RecallAuditPage,
} from 'types/recall-audit';

const AUDIT_LOG_URL = '/marking/dropout/audit-log';

export async function fetchRecallAuditLog(params: RecallAuditListParams) {
    return (await apiClient.get<RecallAuditPage>(AUDIT_LOG_URL, {params})).data;
}

export async function fetchRecallAuditEvent(eventId: string) {
    return (await apiClient.get<RecallAuditEntry>(`${AUDIT_LOG_URL}/${eventId}`)).data;
}

export async function exportRecallAuditEvent(eventId: string) {
    return (
        await apiClient.get<Blob>(`${AUDIT_LOG_URL}/${eventId}/export`, {
            responseType: 'blob',
        })
    ).data;
}

export async function exportRecallAuditLog(
    params: RecallAuditExportParams,
): Promise<RecallAuditExportResult> {
    const response = await apiClient.get<Blob>(`${AUDIT_LOG_URL}/export`, {
        params,
        responseType: 'blob',
    });

    const limit = Number(response.headers['x-export-limit']);
    return {
        data: response.data,
        truncated: response.headers['x-export-truncated'] === 'true',
        ...(Number.isFinite(limit) && {limit}),
    };
}
